import { Badge, Box, Center, Icon, SimpleGrid, Text } from '@chakra-ui/react'
import React, { useContext, useEffect, useState } from 'react'
import { IoAppsOutline, IoCartOutline, IoHeartOutline, IoHomeOutline, IoPersonOutline,IoBookOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';
import AuthContext from '../Routes/hooks/AuthContext';

function AppFooter() {
	// const [cartData,setCartData]=useState
	const { cartList} = useContext(AuthContext)

	// console.log(cartList,'ini di halaman appfooter')
	const getCartData =()=>{
		// console.log(cartList)
		// setCartData(cartList)
	}

	useEffect(() => {
	  getCartData()
	
	  return () => {
		
	  }
	}, [])
	
	
  return (
	<Box mt='5' bgColor='brand.100' shadow='base' position='sticky' bottom={0} p='2'>
		<SimpleGrid columns={5} textAlign='center' fontSize='sm'>
			<Box>
				<Link to='/'>
					<Icon as={IoHomeOutline} boxSize='7'/>
					<Text>Home</Text>
				</Link>
			</Box>
			<Box>
			<Link to='/academy'>
				<Icon as={IoBookOutline} boxSize='7'/>
				<Text>Academy</Text>
			</Link>
			</Box>
			<Center>
				<Box width='20' color='white'  height='20' p='2' borderRadius='full' mt='-9' bgColor='teal' shadow='base'>
				<Link to='/product'>
					<Icon as={IoAppsOutline} boxSize='8'/>
					<Text>Products</Text>
				</Link>
				</Box>
			</Center>
			<Box>
				<Link to='/cart'>
				<Icon as={IoCartOutline} boxSize='7'/>
				<Badge bgColor='red' color='white' mt='-10' ml='-2' borderRadius='full'>{cartList?.products?cartList.products.length:0}</Badge>
				<Text>Cart</Text>
			</Link>
			</Box>
			<Box>
				<Link to='/profile'>

				<Icon as={IoPersonOutline} boxSize='7'/>
				<Text>Profile</Text>
				</Link>
			</Box>
		</SimpleGrid>	
		</Box>
  )
}

export default AppFooter